const textHelpers = {
  getPascalCase(string: string): string {
    return `${string}`
      .replace(new RegExp(/[-_]+/, 'g'), ' ')
      .replace(new RegExp(/[^\w\s]/, 'g'), '')
      .replace(
        new RegExp(/\s+(.)(\w+)/, 'g'),
        (_$1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
      )
      .replace(new RegExp(/\s/, 'g'), '')
      .replace(new RegExp(/\w/), (s) => s.toUpperCase())
  },

  groupBy<T>(list: T[], key: keyof T): Record<string, T[]> {
    return list.reduce((rv: Record<string, T[]>, x: T) => {
      const keyValue = String(x[key])
      ;(rv[keyValue] = rv[keyValue] || []).push(x)
      return rv
    }, {})
  },

  emailValidator(email: string): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  },

  numericValidator(value: string | number): boolean {
    const re = /^(0|[1-9][0-9]*)$/
    return re.test(String(value))
  },
}

export default textHelpers